import type { AnchorHTMLAttributes, ReactNode } from "react";
import { Link as RouterLink } from "react-router";
import { hubPath } from "./current";

// next/link for the copied dashboard screens: "/admin/…" addresses go to the open website's dashboard in the hub; any
// other address (the website's own pages) opens on the website.

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & { href: string; children?: ReactNode; prefetch?: boolean; scroll?: boolean };

export default function Link({ href, prefetch: _prefetch, scroll: _scroll, ...rest }: Props) {
  const to = hubPath(href);
  if (to.startsWith("/sites/")) return <RouterLink to={to} {...rest} />;
  return <a href={href} {...rest} />;
}
